import {
    DISCOUNT_CAMPAIGNS_DETAIL_SUCCESS,
    DISCOUNT_CAMPAIGNS_DETAIL_ERROR,
    DISCOUNT_CAMPAIGNS_DETAIL_START,
    DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_SUCCESS,
    DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_ERROR,
    DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_START,
    DISCOUNT_SHADULE_CAMPAIGNS_SHADULE_FILTER_SUCCESS,
    DISCOUNT_SHADULE_CAMPAIGNS_LIVE_FILTER_SUCCESS,
    DISCOUNT_COMPAIGNS_MODEL_FILTER,
    DISCOUNT_CAMPAIGNS_ALL_FILTER_SUCCESS,
    DISCOUNT_ALL_CAMPAIGNS_DETAIL_SUCCESS,
    DISCOUNT_ALL_CAMPAIGNS_DETAIL_ERROR,
    DISCOUNT_ALL_CAMPAIGNS_DETAIL_START
} from "../Constants/CampaignConstatnt";
    
    const initialState = {
      loading: false,
      discountLivedetail: [],
      discountLiveShaduledetail: [],
      discountLiveFilterdetail: [],
      discountLiveShaduleFilterdetail: [],
      modelFamily:[],
      discountAllDetail:[],
      discountAllFilterDetail:[]
    };
    
    export default function CompagainReducer(
      state = { ...initialState },
      action
    ) {
      switch (action.type) {
        case DISCOUNT_CAMPAIGNS_DETAIL_START:
          return {
            ...state,
            loading: true,
          };
        case DISCOUNT_CAMPAIGNS_DETAIL_SUCCESS:
          return {
            ...state,
            discountLivedetail: action.payload,
            loading: false,
          };
        case DISCOUNT_CAMPAIGNS_DETAIL_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
          case DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_START:
            return {
              ...state,
              loading: true,
            };
          case DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_SUCCESS:
            return {
              ...state,
              discountLiveShaduledetail: action.payload,
              loading: false,
            };
          case DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_ERROR:
            return {
              ...state,
              loading: false,
              message: action.error.message,
            };
            case DISCOUNT_SHADULE_CAMPAIGNS_LIVE_FILTER_SUCCESS:
              return {
                ...state,
                discountLiveFilterdetail: action.payload,
                loading: false,
              };
            case DISCOUNT_SHADULE_CAMPAIGNS_SHADULE_FILTER_SUCCESS:
              return {
                ...state,
                discountLiveShaduleFilterdetail: action.payload,
                loading: false,
              };
              case DISCOUNT_COMPAIGNS_MODEL_FILTER:
                return {
                  ...state,
                  modelFamily: action.payload,
                  loading: false,
                };
                case DISCOUNT_ALL_CAMPAIGNS_DETAIL_START:
                  return {
                    ...state,
                    loading: true,
                  };
                case DISCOUNT_ALL_CAMPAIGNS_DETAIL_SUCCESS:
                  return {
                    ...state,
                    discountAllDetail: action.payload,
                    loading: false,
                  };
                case DISCOUNT_ALL_CAMPAIGNS_DETAIL_ERROR:
                  return {
                    ...state,
                    loading: false,
                    message: action.error.message,
                  };
                case DISCOUNT_CAMPAIGNS_ALL_FILTER_SUCCESS:
                  return {
                    ...state,
                    discountAllFilterDetail: action.payload,
                    loading: false,
                  };
        default:
          return state;
      }
    }
    